import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 1.2rem;
`;

export { Container };
